<template lang="pug">
v-container(fluid).chapter-category-page
  portal(to='toolbar')
    v-toolbar-title Training Chapters
  v-card
    .body.inner-scroll
      .d-flex.align-center.justify-between.mr-3.py-3
        ChapterCategoriesFilters(
          :loading="listLoading"
          @filterChanged="loadList"
          ref="filters"
        )
        v-btn(fab color="primary" @click="showItemCreate" small).ml-auto
          v-icon(small) $vuetify.icons.plus
      list(
        :loading="listLoading"
        @removeClicked="remove"
        @loadMoreClick="loadListMore"
        @itemEditClick="showItemEdit"
        disable-sorting
        :list="list"
        :pagination="pagination"
        v-slot="{item}"
        :headers="headers"
        hide-select
        @onReorder="sortItems"
      )
        td.pl-4 {{ item.name }}
        td {{ item.description }}
        td
          span.license-types {{ item.licenseTypes }}
        td.text-center
          .tenant-badges
            .tenant-badge.tenant-wiki(v-if="item.is_wiki") Wiki
            .tenant-badge.tenant-les(v-if="item.is_les") Les
            .tenant-badge.tenant-online(v-if="item.is_online") Online
        td.text-center
          statusButton( v-if="item.isDemo" :status="item.isDemo")
        td.text-center
          statusButton(:status="item.publicVisible")
        td.text-center
          img(
            :src="getCategoryImage(item.thumbnail)"
            :alt="item.name"
          ).category-img
      item-modal(
        v-model="itemModalVisible"
        :itemModel="editItemModel"
        :editMode="isEditMode"
        @itemCreated="loadList"
        @itemUpdated="loadList"
      )
</template>
<script>
import ChapterCategorySvc from "@/app/exercise/modules/training-chapter-categories/core/chapter-category-service"
import ErrorMixin from "@/mixins/errors.mixin"
import FormErrors from "@/util/form-errors"
import PaginationMixin from "@/mixins/pagination.mixin"
import ChapterCategoriesFilters
  from "@/app/exercise/modules/training-chapter-categories/components/ChapterCategoriesFilters.vue";
// import Sortable from 'sortablejs';
export default {
  components: {
    ChapterCategoriesFilters,
    list: () => import('@/app/exercise/components/ItemsList'),
    itemModal: () => import('./components/ChapterCategoryModal.vue'),
    statusButton: () => import('@/app/exercise/components/StatusButton'),
  },

  computed: {
  },

  data: () => ({
    svc: null,
    list: [],
    listLoading: false,
    formErrors: null,
    pagination: null,
    itemModalVisible: false,
    isEditMode: false,
    editItemModel: null,
    headers: [
      { text: 'Name', align: 'left', class: 'pl-4'},
      { text: 'Description'},
      { text: 'License types', align: 'left' },
      { text: 'Tenant', align: 'center'},
      { text: 'Demo', align: 'center'},
      { text: 'Public visible', align: 'center'},
      { text: 'Thumbnail', align: 'center'},
      { text: 'Actions', align: 'center', value: 'menu', class: "w-100" },
    ],
  }),

  mixins: [ErrorMixin, PaginationMixin],

  watch: {
    itemModalVisible(isVisible) {
      if (!isVisible) {
        this.clearItemModal();
      }
    },
  },

  created() {
    this.init()
  },

  async mounted() {
    await this.setDefaultPagination()
    this.loadData()
  },

  methods: {
    init() {
      this.svc = new ChapterCategorySvc(this.$auth)
      this.formErrors = new FormErrors()
    },

    async sortItems(itemIds) {
      const data = await this.svc.sort({
        ids: itemIds,
      });
    },

    getCategoryImage(categoryThumbnail) {
      return categoryThumbnail ? categoryThumbnail : require('@/assets/img/chapters/chapter-img.png');
    },

    clearItemModal() {
      this.isEditMode = false;
      this.editItemModel = {};
    },

    loadData() {
      Promise.all([
        this.loadList(),
      ])
    },

    showItemEdit(item) {
      this.itemModalVisible = true;
      this.isEditMode = true;
      this.editItemModel = item;
    },

    showItemCreate() {
      this.itemModalVisible = true;
    },

    async loadList() {
      try {
        this.listLoading = true
        let { results, pagination} = await this.svc.list(this.$route.query)
        this.pagination = pagination;
        this.list = results
        this.listLoading = false
      } catch (error) {
        this.listLoading = false
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }

    },

    async loadListMore(page) {
      try {
        this.listLoading = true
        let { results } = await this.svc.list({
          ...this.$route.query,
          page
        })
        this.list.push(...results)
        this.listLoading = false
      } catch (error) {
        this.listLoading = false
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    },

    async remove(item) {
      try {
        let itemIndex = this.list.findIndex(listItem => listItem.id === item.id)
        if(itemIndex < 0) throw new Error('This item was not found in the list.')
        await this.svc.remove(item)
        this.pagination.count -= 1;
        this.list.splice(itemIndex, 1);
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    },

  },
}
</script>
<style lang="scss" scoped>
.chapter-category-page::v-deep {
  .category-img {
    max-width: 40px;
    border-radius: 50%;
  }
  .w-100 {
    width: 100px;
  }
  .item-image {
    max-width: 150px;
    max-height: 100px;
  }
  .v-card {
    .card-header {
      height: 64px;
    }
    .body {
      height: 100vh;
      max-height: calc(100vh - 90px);
      overflow: auto;
      &.inner-scroll {
        overflow: hidden;
        display: flex;
        flex-direction: column;
      }
    }
  }
}

.license-types {
  font-size: 12px;
  margin-top: 4px;
}

.tenant-badges {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: center;
}

.tenant-badge {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 500;
  text-transform: uppercase;
  
  &.tenant-wiki {
    background-color: #e3f2fd;
    color: #1976d2;
  }
  
  &.tenant-les {
    background-color: #f3e5f5;
    color: #7b1fa2;
  }
  
  &.tenant-online {
    background-color: #e8f5e8;
    color: #388e3c;
  }
}
</style>
